import request from '@/utils/request'

/**
 * 技师特定日期排班覆盖相关API
 */
let ScheduleOverrideApi = {
  /**
   * 获取技师特定日期排班覆盖列表
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  getList(data, errorback) {
    return request._post('/supplier/technician.scheduleOverride/index', data, errorback);
  },
  /**
   * 添加技师特定日期排班覆盖
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  add(data, errorback) {
    return request._post('/supplier/technician.scheduleOverride/add', data, errorback);
  },
  /**
   * 修改技师特定日期排班覆盖
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  edit(data, errorback) {
    return request._post('/supplier/technician.scheduleOverride/edit', data, errorback);
  },
  /**
   * 删除技师特定日期排班覆盖
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  del(data, errorback) {
    return request._post('/supplier/technician.scheduleOverride/delete', data, errorback);
  },
  /**
   * 获取技师特定日期排班覆盖详情
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  detail(data, errorback) {
    return request._post('/supplier/technician.scheduleOverride/detail', data, errorback);
  },
  /**
   * 获取技师指定日期范围的排班覆盖
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  getDateRangeSchedule(data, errorback) {
    return request._post('/supplier/technician.scheduleOverride/getDateRangeSchedule', data, errorback);
  },
  /**
   * 批量设置技师特定日期排班覆盖
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  batchSet(data, errorback) {
    return request._post('/supplier/technician.scheduleOverride/batchSet', data, errorback);
  },
  /**
   * 检查技师特定日期排班冲突
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  checkConflict(data, errorback) {
    return request._post('/supplier/technician.scheduleOverride/checkConflict', data, errorback);
  }
}

export default ScheduleOverrideApi;



// WEBPACK FOOTER //
// ./src/api/technician/scheduleOverride.js